import React, { memo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { DialogPositiveActionButton } from "../../../../components";

function ReportListDialog({ open, close, title, children }) {
  const { message: closeMessage, onClose } = close;
  return (
    <Dialog open={open} maxWidth="md" onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        <DialogPositiveActionButton onClick={onClose}>
          {closeMessage}
        </DialogPositiveActionButton>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ReportListDialog);
